export const PlusIcon = ({ color = '#fff', ...restProps }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M8 3.33337V12.6667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33337 8H12.6667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
